module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/header_bg-7f73e85e80151ee0d4835ec60110b49b.png";